import { createStore } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import { localStorage } from '../utils/browserStorage'
import rootReducer from './reducers'

const storage = {
	getItem: (key: string) => Promise.resolve(localStorage.getItem(key)),
	setItem: (key: string, value: string) => { localStorage.setItem(key, value); return Promise.resolve(); },
	removeItem: (key: string) => { localStorage.removeItem(key); return Promise.resolve(); },
}

export default () => {
	const persistConfig = {
		key: 'root',
		storage,
	}
	const persistedReducer = persistReducer(persistConfig, rootReducer)
	const store = createStore(persistedReducer)
	const persistor = persistStore(store)
	return { store, persistor }
}
